import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Main from './Main'
import Detail from './e2e/Detail'

const E2E = () => {
  return (
    <Routes>
      <Route path="" element={<Main />} />
      <Route path=":clientcode/:date/:relnr" element={<Detail />} />
    </Routes>
  )
}

export default E2E